import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Autocomplete,
  Box,
  Button,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
  Alert,
  AlertTitle,
  Pagination,
} from "@mui/material";
import GetAppIcon from "@material-ui/icons/GetApp";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useEffect, useState } from "react";
import { getRequest } from "../../../globalhelper/helper";
import { KeyboardArrowLeft, KeyboardArrowRight } from "@material-ui/icons";
import LastPageIcon from "@mui/icons-material/LastPage";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import { useDispatch } from "react-redux";
import { hideLoader, showLoader } from "../../../redux/Common/commonActions";
import { CSVLink } from "react-csv";
import { GetApp } from "@mui/icons-material";
import moment from "moment";

function Budget_Vs_Actuals() {
  let [formData, setFromdata] = useState({});
  let [PeIDs, setPEIds] = useState(null);
  let [Companies, setCompanies] = useState(null);
  let [Reports, setReports] = useState([]);
  let [message, setMessage] = useState(null);
  let [types, setTypes] = useState([
    "Summary PE vs PO vs GSE",
    "List of POs with Items",
    "List of GSEs with Items",
    "List of PE Items",
    "Budget Vs Actuals Report",
  ]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  let dispatch = useDispatch();

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    getRequest(`api/edureka/getCompanyAssignedToUser`)
      .then(({ res }) => {
        setCompanies(
          (res.data || []).sort((a, b) =>
            (a.orgname || "").localeCompare(b.orgname || ""),
          ),
        );
        if (res.data.length === 1) {
          handleChanges("Company", res.data[0]);
        }
      })
      .catch((error) => console.log(error));
    //   var currentDate = moment()
    //   var firstDay = currentDate.startOf('month').format('YYYY-MM-DD')
    //   var lastDay = currentDate.endOf('month').format('YYYY-MM-DD')
    //   setFrom(firstDay)
    //   setTo(lastDay)
  }, []);

  const handleChanges = (name, value) => {
    setFromdata({ ...formData, [name]: value });
    if (name == "Company") {
      getRequest(`api/dashboard/getIP2?orgid=${value.orgid}`)
        .then(({ res }) => {
          const parsed = JSON.parse(res.data || "[]");

          const sorted = parsed.sort((a, b) => {
            const aVal = a?.["IP Number"] ?? "";
            const bVal = b?.["IP Number"] ?? "";
            return aVal.localeCompare(bVal);
          });

          setPEIds(sorted);
        })
        .catch((error) => console.log(error));
    }
  };

  const handleSubmit = async () => {
    try {
      dispatch(showLoader());
      setReports([]);
      let { res } = await getRequest(
        `api/vr2/getPEReports?orgid=${formData.Company.orgid}&peId=${formData.PeId["IP Number"]}&type=${formData.type}`,
      );
      if (res.status != "success") {
        setMessage(
          <Box sx={{ margin: "auto" }}>
            <Alert severity="warning">
              <AlertTitle>No Data Found</AlertTitle>
              Problem with connecting server.
            </Alert>
          </Box>,
        );
        return;
      }
      let parsedData = JSON.parse(res.data);
      if (parsedData.length === 0) {
        setMessage(
          <Box sx={{ margin: "auto" }}>
            <Alert severity="warning">
              <AlertTitle>No Data Found</AlertTitle>
              There is no data to display at the moment.
            </Alert>
          </Box>,
        );
        return;
      } else {
        setMessage(null);
      }
      setReports(parsedData);
    } catch (error) {
      console.log(error);
    } finally {
      setPage(0);
      dispatch(hideLoader());
    }
  };

  function TablePaginationActions(props) {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;
    const [previousCount, setPreviousCount] = useState(count);

    useEffect(() => {
      if (count !== previousCount && page !== 0) {
        onPageChange(null, 0);
      }
      setPreviousCount(count);
    }, [count, page, onPageChange, previousCount]);

    const handleFirstPageButtonClick = (event) => {
      onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
      onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
      onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
      onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
      <Box sx={{ flexShrink: 0, ml: 2.5 }}>
        <IconButton
          onClick={handleFirstPageButtonClick}
          disabled={page === 0}
          aria-label="first page"
        >
          {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
        </IconButton>
        <IconButton
          onClick={handleBackButtonClick}
          disabled={page === 0}
          aria-label="previous page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowRight />
          ) : (
            <KeyboardArrowLeft />
          )}
        </IconButton>
        <IconButton
          onClick={handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="next page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowLeft />
          ) : (
            <KeyboardArrowRight />
          )}
        </IconButton>
        <IconButton
          onClick={handleLastPageButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="last page"
        >
          {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
        </IconButton>
      </Box>
    );
  }

  TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
  };

  return (
    <>
      <Accordion defaultExpanded>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <Typography variant="h6">Search Reports</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container gap={2}>
            <Grid item xs={1} sm={2} md={3}>
              <Autocomplete
                size="small"
                fullWidth
                value={formData?.Company || null}
                options={Companies || []}
                getOptionLabel={(option) => option?.orgname || ""}
                isOptionEqualToValue={(option, value) =>
                  option?.orgid === value?.orgid
                }
                onChange={(event, newValue) =>
                  handleChanges("Company", newValue)
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Company"
                    variant="outlined"
                    name="Company"
                  />
                )}
              />
            </Grid>
            <Grid item xs={1} sm={2} md={3}>
              <Autocomplete
                size="small"
                fullWidth
                value={formData.PeId || null}
                options={PeIDs || []}
                getOptionLabel={(option) => option?.["costcentre"] || ""}
                isOptionEqualToValue={(option, value) =>
                  option?.["IP Number"] === value?.["IP Number"]
                }
                onChange={(event, newValue) => handleChanges("PeId", newValue)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Project"
                    variant="outlined"
                    name="PeId"
                  />
                )}
              />
            </Grid>
            <Grid item xs={1} sm={2} md={3}>
              <Autocomplete
                size="small"
                fullWidth
                value={formData.type || null}
                options={types || []}
                onChange={(event, newValue) => handleChanges("type", newValue)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Reports Type"
                    variant="outlined"
                    name="type"
                  />
                )}
              />
            </Grid>
            <Grid item xs={2}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleSubmit}
              >
                Submit
              </Button>
              &nbsp;&nbsp;
              <Button
                variant="contained"
                color="error"
                onClick={() => {
                  setFromdata({});
                  setReports([]);
                }}
              >
                Reset
              </Button>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
      {Reports.length > 0 ? (
        <>
          <Box
            align="right"
            sx={{
              m: 2,
              display: "flex",
              justifyContent: "flex-end",
              flexDirection: "row",
              gap: 2,
            }}
          >
            <>
              <Pagination
                count={Math.ceil(Reports.length / rowsPerPage)}
                page={page + 1}
                onChange={(event, newPage) => {
                  handleChangePage(event, newPage - 1);
                }}
                variant="outlined"
                shape="rounded"
                showFirstButton
                showLastButton
              />
              &nbsp;
              <CSVLink
                size="sm"
                filename={`${formData.type}_${moment().format(
                  "YYYY-MM-DD_HH-mm-ss",
                )}.csv`}
                data={Reports}
              >
                <Button variant="contained" color="success">
                  <GetApp />
                </Button>
              </CSVLink>
            </>
          </Box>
          <TableContainer component={Paper}>
            <Table aria-label="custom pagination table">
              <TableHead>
                <TableRow>
                  {Reports[0] &&
                    Object.keys(Reports[0]).map((key, index) => (
                      <TableCell
                        key={index}
                        align="center"
                        sx={{ whiteSpace: "nowrap" }}
                      >
                        <b>
                          {key.includes("_") &&
                            formData.type !== "Budget Vs Actuals Report"
                            ? key.split("_")[0]
                            : key}
                        </b>
                      </TableCell>
                    ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {(rowsPerPage > 0
                  ? Reports.slice(
                    page * rowsPerPage,
                    page * rowsPerPage + rowsPerPage,
                  )
                  : Reports
                ).map((row) => (
                  <TableRow key={row.sno}>
                    {Reports[0] &&
                      Object.keys(row).map((key, index) => (
                        <TableCell key={index} align="center" sx={{ p: 0.3 }}>
                          {row[key]}
                        </TableCell>
                      ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </>
      ) : (
        ""
      )}
      {message}
    </>
  );
}

export default Budget_Vs_Actuals;
